import React, { useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import torchx from "../../assets/images/LandingModal/TorchX-Talent-14-days-trial.png";

<img src={torchx} alt="torchx" />


const LandingModal = ({ cooldownHours = 6 }) => {
  const [show, setShow] = useState(false);
const COOLDOWN_PERIOD = 0.5 * 60 * 60 * 1000; // 30 minutes
//   const COOLDOWN_PERIOD = 1 * 1000; // 1 second (dev)


  useEffect(() => {
    const lastShown = localStorage.getItem("lastModalShown");
    const now = Date.now();

    if (!lastShown || now - lastShown > COOLDOWN_PERIOD) {
      setShow(true);
      localStorage.setItem("lastModalShown", now);
    }
  }, [COOLDOWN_PERIOD]);

  const handleClose = () => setShow(false);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header>
        <Modal.Title><strong>Get your 14 days free trial now!</strong></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* <p>
          We’re hiring<strong> Sales Executives</strong>{" "}
          for Indian campaigns. <strong>Fresher and  experienced candidates may apply</strong>{" "}
          for the following profile.
        </p>
        <h5 className="mt-4 text-bold">Open Vacancies </h5>
        <Table
          bordered
          hover
          responsive
          size="sm"
          className="mt-3 text-center align-middle"
        >
          <thead className="table-light">
            <tr>
              <th>Profile</th>
              <th>Required Experienced</th>
              <th>Campagin Type</th>
            </tr>
          </thead>
          <tbody>

            <tr>
              <td>Sale Executive(Voice)</td>
              <td>Fresher | 1 Year | 2 Year </td>
              <td>Indian</td>
            </tr>
             <tr>
              <td>Customer Support Executives (Voice)</td>
              <td>1 Year | 2 Years | 3 Years </td>
              <td>International</td>
            </tr>
            <tr>
              <td>Customer Support Executives (chat)</td>
              <td>06 Months | 1 Years | 2 Years</td>
              <td>International</td>
            </tr>
            <tr className="table-success">
              <td>Data Entry Specialist</td>
              <td>1 Years</td>
              <td>Domestic</td>
            </tr>
            <tr className="table-success">
              <td>Back End Specialist</td>
              <td>1 Years</td>
              <td>Domestic</td>
            </tr> 
            <tr className="table-success">
              <td>Software Engineer Trainee (Intern)</td>
              <td>Fresher</td>
              <td>NA</td>
            </tr>
          </tbody>
        </Table>
        <p className="mt-4">
          Interested candidates can apply on <strong> anshika.pandey@techtorch.solutions </strong> for <strong> details </strong>you 
          can do WhatsApp on +91 70783 77916 . <br/>

         {/* <span className="text-danger"><strong>Note:</strong> <u>This is a Work From Home opportunity. All software engineering internships will be conducted remotely.
          </u></span> 
            
        </p>

        <p className="fw-semibold text-center text-secondary mt-3">
          🔗 Let’s grow together — collaborate with us on these exciting new
          opportunities!
          <br/>
          <p className="h6"><em>*Terms & Conditions Apply.</em></p>
        
        </p> */}
      <a href='https://torchxsuite.com/'> <img className="img-fluid" src={torchx} alt="TorchX Talent" /></a>
      </Modal.Body>

      <Modal.Footer>
       <Button
          variant="success"
          href="https://wa.me/7078377916" // replace with your number
          target="_blank"
          rel="noopener noreferrer"
        >
          💬 Chat Now
        </Button>

        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LandingModal;
